import axios from "axios";

export const state = {
    studymaterials: [],
};

export const getters = {
    studymaterials: state => state.studymaterials,
};

export const mutations = {
    setStudymaterials(state, newValue) {
        state.studymaterials = newValue
    },
};

export const actions = {
    fetchStudyMaterials({ commit }) {
        axios.get('/studymaterials').then(res => {
            commit('setStudymaterials', res.data.studymaterials)
        })
    },
    filterMaterial({commit}, {schoolterm,year}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        let url = "/filterstudymaterials";
        axios.post(url, formData).then((response) => {
            commit('setStudymaterials', response.data.studymaterials)
        })
    },
};
